var _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMailinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 117 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 78h115V1H1v77z",
    fill: "#009ee0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 78h115V1H1v77z",
    fill: "none",
    stroke: "#364148",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 78l58.03-40.6L116 77.557",
    fill: "none",
    stroke: "#364148",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.153 50.847L115.478 1.38H.828l57.325 49.467z",
    fill: "url(#mail_inline_svg__mail_inline_svg___Linear1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.329 51.08l57.149-49.7H1.179l57.15 49.7z",
    fill: "none",
    stroke: "#364148",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mail_inline_svg__mail_inline_svg___Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(.828 26.113) scale(114.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005791",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0086c7",
    stopOpacity: 1
  })))));
}

export default SvgMailinline;